import _ from "lodash";
import { useMemo } from "react";
import { ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import InsightFailed from "./InsightFailed";
import { useQueryAllAccounts } from "../clients/account/lib";
import { useQueryHouseholds } from "../clients/household/lib";
import {
  accountsWithoutFeeStructure,
  accountsWithoutModel,
  householdsWithoutFeeStructure,
  householdsWithoutModel,
} from "./insightRegistry";

const UnassignedFeeStructuresModels = () => {
  const { isPending: isPendingHouseholds, data: dataHouseholds } =
    useQueryHouseholds({ includeBalances: true });
  const households = dataHouseholds?.data;

  const { isPending: isPendingAccounts, data: dataAccounts } =
    useQueryAllAccounts({ includeBalances: true });
  const accounts = dataAccounts?.data;

  const householdIdsWithoutFeeStructure = useMemo(
    () =>
      householdsWithoutFeeStructure(households ?? []).map(
        (household) => household.id,
      ),
    [households],
  );

  const householdIdsWithoutModel = useMemo(
    () =>
      householdsWithoutModel(households ?? []).map((household) => household.id),
    [households],
  );

  const mapHouseholds = useMemo(() => _.keyBy(households, "id"), [households]);

  const accountIdsWithoutFeeStructure = useMemo(
    () =>
      accountsWithoutFeeStructure(accounts ?? [], mapHouseholds).map(
        (account) => account.id,
      ),
    [accounts, mapHouseholds],
  );

  const accountIdsWithoutModel = useMemo(
    () =>
      accountsWithoutModel(accounts ?? [], mapHouseholds).map(
        (account) => account.id,
      ),
    [accounts, mapHouseholds],
  );

  return isPendingHouseholds || isPendingAccounts ? (
    <ListGroupItem>
      <Loading />
    </ListGroupItem>
  ) : typeof households === "undefined" || typeof accounts === "undefined" ? (
    <InsightFailed />
  ) : (
    <>
      {(householdIdsWithoutFeeStructure.length > 0 ||
        accountIdsWithoutFeeStructure.length > 0) && (
        <ListGroupItem>
          You have{" "}
          {householdIdsWithoutFeeStructure.length <= 0 ? (
            "0 Households with AUM"
          ) : (
            <Link to="/clients/households?insight=households-no-fee-structure">
              {householdIdsWithoutFeeStructure.length} Households with AUM
            </Link>
          )}{" "}
          and{" "}
          {accountIdsWithoutFeeStructure.length <= 0 ? (
            "0 Accounts with AUM"
          ) : (
            <Link to="/clients/accounts?insight=accounts-no-fee-structure">
              {accountIdsWithoutFeeStructure.length} Accounts with AUM
            </Link>
          )}{" "}
          that do not have fee structures.
        </ListGroupItem>
      )}
      <ListGroupItem>
        You have{" "}
        {householdIdsWithoutModel.length <= 0 ? (
          "0 Households"
        ) : (
          <Link to="/clients/households?insight=households-no-model">
            {householdIdsWithoutModel.length} Households
          </Link>
        )}{" "}
        and{" "}
        {accountIdsWithoutModel.length <= 0 ? (
          "0 Accounts"
        ) : (
          <Link to="/clients/accounts?insight=accounts-no-model">
            {accountIdsWithoutModel.length} Accounts
          </Link>
        )}{" "}
        with AUM that do not have models assigned.
      </ListGroupItem>
    </>
  );
};

export default UnassignedFeeStructuresModels;
